import React from 'react';
import { makeStyles } from '@fluentui/react-components';

const useStyles = makeStyles({
    serviceTag: {
        flex: '1 1 auto',
        minWidth: 'fit-content',
        paddingLeft: '40px',
        paddingRight: '40px',
        paddingTop: '20px',
        paddingBottom: '20px',
        backgroundColor: '#FFFCF5',
        borderRadius: '40px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '10px',
        display: 'flex',
        '@media (max-width: 768px)': {
            paddingLeft: '20px',
            paddingRight: '20px',
            paddingTop: '12px',
            paddingBottom: '12px',
            flex: '0 1 auto',
        },
    },

    serviceTagText: {
        textAlign: 'center',
        color: '#222222',
        fontSize: '32px',
        fontFamily: 'Figtree',
        fontWeight: 400,
        lineHeight: '44.80px',
        wordWrap: 'break-word',
        '@media (max-width: 768px)': {
            fontSize: '16px',
            lineHeight: '22.40px',
        },
    },

    serviceTagTextBold: {
        textAlign: 'center',
        color: '#C6A972',
        fontSize: '32px',
        fontFamily: 'Figtree',
        fontWeight: 700,
        lineHeight: '44.80px',
        wordWrap: 'break-word',
        '@media (max-width: 768px)': {
            fontSize: '16px',
            lineHeight: '22.40px',
        },
    },
});

interface AlyzeServiceTagProps {
    text: string;
    isBold?: boolean;
}


const AlyzeServiceTag: React.FC<AlyzeServiceTagProps> = ({ text, isBold = false }) => {
    const styles = useStyles();

    return (
        <div className={styles.serviceTag}>
            <div className={isBold ? styles.serviceTagTextBold : styles.serviceTagText}>
                {text}
            </div>
        </div>
    );
};

export { AlyzeServiceTag };
